import { render, staticRenderFns } from "./star_count.vue?vue&type=template&id=5e23cea1"
import script from "./star_count.vue?vue&type=script&lang=js"
export * from "./star_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports